import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { setAuthorizationOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { OptionsService } from '../services/options.service'

export function* getAuthorizationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const authorizationResponse: IOptionsResponse = yield call([optionsService, optionsService.getAuthorizationOptions])
    const { entity } = authorizationResponse
    yield put(setAuthorizationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getResponseOptions() error: ${e}`))
  }
}

export function* getAuthorizationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAuthorizationOptions)
}
